exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.hs8_code[data-v-ca37b0aa] {\n  display: block;\n  max-height: 60px;\n  min-height: 60px;\n  height: 60px;\n  padding: 10px;\n  font-size: 11px;\n  line-height: normal;\n  max-width: 100%;\n  font-weight: lighter;\n}\n", ""]);
